import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {addProduct} from '~/actions/ProductActions';
import {confirm} from '~/actions/NotificationActions';

import Notification from '~/components/Notification';
import {SUPPORT_PHONE_NUMBER} from '~/constants/ContactConstants';
import {VIEW_DISPLAY_NAME_MAP} from '~/constants/ProductConstants';
import {nbsp} from '~/constants/StringConstants';
import {Button, Link} from '@customink/pigment-react';

const propTypes = {
  addProduct: PropTypes.func,
  confirm: PropTypes.func,
  dismiss: PropTypes.func,
  notification: PropTypes.shape({
    payload: PropTypes.shape({
      metricsEnabled: PropTypes.bool,
      productName: PropTypes.string,
      products: PropTypes.arrayOf(PropTypes.object),
      retainedViewsWithIcons: PropTypes.arrayOf(PropTypes.number),
      urlPath: PropTypes.string
    })
  })
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
export class AddProductMissingAreas extends Component {
  static displayName = 'AddProductMissingAreas';
  static propTypes = propTypes;

  addProductAnyway = () => {
    const {notification, addProduct, confirm} = this.props;
    const origParams = notification?.payload || {};
    addProduct({
      ...origParams,
      overrideNotification: true
    });
    confirm();
  };

  render() {
    const retainedViews =
      this.props.notification?.payload?.retainedViewsWithIcons
        ?.map(v => VIEW_DISPLAY_NAME_MAP[v])
        .join(', ');

    return (
      <Notification
        dismiss={this.props.dismiss}
        title={
          <span>
            Whoops! This product does not support <br /> one or more of your
            design areas.
          </span>
        }
        type="ERROR">
        <br />
        <p className="ndx-cta1">
          If you add the
          {nbsp}
          {this.props.notification?.payload?.productName},{nbsp}
          we will only retain the {retainedViews} design(s). Call us at
          {nbsp}
          <Link href={SUPPORT_PHONE_NUMBER.TEL_LINK}>
            {SUPPORT_PHONE_NUMBER.COPY}
          </Link>
          {nbsp}
          for more help.
        </p>
        <Button
          size="large"
          variant="Primary"
          className="notification-cta"
          onClick={this.addProductAnyway}>
          CONTINUE
        </Button>
        <p className="ndx-cta1">
          <br />
          or
          {nbsp}
          <Link
            href={this.props.notification?.payload?.urlPath}
            onClick={this.props.dismiss}>
            choose another product.
          </Link>
        </p>
      </Notification>
    );
  }
}

function actions(dispatch) {
  return bindActionCreators(
    {
      addProduct,
      confirm
    },
    dispatch
  );
}

export default connect(null, actions)(AddProductMissingAreas);
